module.exports = __webpack_public_path__ + "static/TiemposTextWeb-RegularItalic-8be87f36423946c95e7a4d762619a682.eot";